export interface ContextOption {
  id: number;
  parentId?: number;
  questionText: string;
  questionDescription: string;
  lenderNodeText: string;
  hierarchyId: number;
  questionId: number;
  flowType: string;
  contextNotes: string;
  editNodeId: number;
  live: boolean;
  internal: boolean;
  brokerVisible: boolean;
  lenderVisible: boolean;
  smartrFitVisible: boolean;
  verified: any;
  lowerRange?: number;
  upperRange?: number;
  value: string;
  sortOrder?: number;
}

export interface IssuesContextSearchViewModel {
  issues: ContextOption[];
  contexts: ContextOption[];
}
